"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiaryDashboardView = void 0;
var React = require("react");
require("./style.scss");
var NewEntryCalendar_1 = require("../DiaryEntriesView/Modals/NewEntryCalendar");
var react_router_dom_1 = require("react-router-dom");
var react_redux_1 = require("react-redux");
var recompose_1 = require("recompose");
var Types = require("types");
var acl = require("@caddigital/sok-reducers/lib/utils/acl");
var moment = require("moment-timezone");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var Greeting_1 = require("components/Greeting");
var translate_1 = require("utils/translate");
var text_1 = require("utils/text");
var diaryActions = require("@caddigital/sok-reducers/lib/actions/sokosite/current");
var diaryEntriesActions = require("@caddigital/sok-reducers/lib/actions/diaryentries/list");
var statsActions = require("@caddigital/sok-reducers/lib/actions/diaryentries/stats");
var NotFoundPlaceHolder_1 = require("components/NotFoundPlaceHolder");
var index_1 = require("./PieChart/index");
var WorksiteStatus_1 = require("./WorksiteStatus");
var mapStateToProps = function (state, ownProps) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    return {
        status: state.sokosite.current.status,
        worksiteDiary: state.sokosite.current.worksiteDiary,
        entries: state.diaryentries.list,
        selectedLanguage: selectedLanguage,
        stats: state.diaryentries.stats,
        viewportSize: state.viewport.size
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    fetchCurrentDiary: function (id) { return dispatch(diaryActions.fetchRequest(id)); },
    fetchDiaryEntries: function (diaryUuid, limit) {
        return dispatch(diaryEntriesActions.fetchRequest(diaryUuid, limit));
    },
    clearState: function () { return dispatch(diaryActions.clear()); },
    fetchDiaryStats: function (diaryUuid) {
        return dispatch(statsActions.fetchRequest(diaryUuid));
    }
}); };
var statePropsExtractable = Types.extractReturnType(mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), react_router_dom_1.withRouter, (0, recompose_1.lifecycle)({
    componentWillMount: function () {
        this.props.fetchCurrentDiary(this.props.match.params.id);
        this.props.fetchDiaryEntries(this.props.match.params.id, 8);
        this.props.fetchDiaryStats(this.props.match.params.id);
    },
    componentWillUnmount: function () {
        this.props.clearState();
    }
}), recompose_1.pure);
var entryRows = function (entries, props) {
    if (!props.selectedLanguage ||
        !props.currentProject ||
        !props.worksiteDiary) {
        return;
    }
    var baseUrl = "/".concat(props.selectedLanguage, "/projects/").concat(props.currentProject.id, "/sokosite/worksitediary/").concat(props.worksiteDiary.diary_uuid);
    var rows = entries.map(function (e) {
        return (React.createElement("div", { key: e.id, className: 'entry-row' },
            React.createElement(react_router_dom_1.Link, { to: "".concat(baseUrl, "/entries/").concat(e.entry_uuid) }, moment(e.diary_date).format('L')),
            React.createElement("span", { className: "created-by" }, (0, translation_1.getLocalization)('addedBy') + ' ' + e.created_by)));
    });
    return (React.createElement(React.Fragment, null,
        rows && rows.length > 0 ? (React.createElement("div", { className: 'entry-rows' }, rows)) : props.entries.status !== 'FETCHED' ? (React.createElement("div", null)) : (React.createElement(NotFoundPlaceHolder_1.NotFoundPlaceHolder, { title: 'diaryEntriesView/emptyList/title', message: 'diaryEntriesView/emptyList/message', key: 'no-entries', className: 'no-content' })),
        React.createElement("div", { className: 'more' },
            React.createElement(react_router_dom_1.Link, { to: "".concat(baseUrl, "/entries") }, (0, translation_1.getLocalization)('showMore')))));
};
exports.DiaryDashboardView = enhance(function (props) {
    if (props.status === 'FETCHING') {
        return (React.createElement("div", { className: 'worksite-diary-view' },
            React.createElement("div", { className: 'loading' },
                React.createElement(sok_ui_1.LoadingSpinner, null))));
    }
    else if (props.status === 'FAILED') {
        return (React.createElement("div", { className: 'worksite-diary-view' },
            React.createElement(NotFoundPlaceHolder_1.NotFoundPlaceHolder, { className: "no-diary", key: "no-diary", title: "diaryEntriesView/emptyList/title", message: "diary/dashboard/error/message" })));
    }
    var selectedLanguage = (0, translate_1.getLanguage)();
    var perm = props.currentProject && props.currentProject.perm
        ? props.currentProject.perm
        : 0x00;
    var worksiteDiaryPerm = props.worksiteDiary && props.worksiteDiary.perm
        ? props.worksiteDiary.perm
        : 0x00;
    var _a = React.useState(false), show = _a[0], setShow = _a[1];
    var _b = React.useState(moment().toDate()), startDate = _b[0], setStartDate = _b[1];
    var openModal = function () { return setShow(true); };
    var closeModal = function () { return setShow(false); };
    var setDate = function (date) { return setStartDate(date); };
    var current = new Date();
    var day = "".concat(current.getDate());
    var year = "".concat(current.getFullYear());
    var monthName = moment().format('MMMM');
    return (React.createElement("div", { className: 'content-wrapper-content' },
        React.createElement("div", { className: 'worksite-diary-view' },
            React.createElement("main", { className: 'content' },
                React.createElement(sok_ui_1.BreadCrumb, null,
                    props.currentProject ? (React.createElement(react_router_dom_1.Link, { to: "/".concat(selectedLanguage, "/projects/").concat(props.currentProject.id) }, props.currentProject.name)) : (React.createElement(react_router_dom_1.Link, { to: "/".concat(selectedLanguage) }, "SokoPro")),
                    props.currentProject && (React.createElement(react_router_dom_1.Link, { to: "/".concat(selectedLanguage, "/projects/").concat(props.currentProject.id, "/sokosite") }, (0, translation_1.getLocalization)('breadcrumb/sokosite'))),
                    props.currentProject &&
                        props.worksiteDiary &&
                        props.worksiteDiary.name && (React.createElement(react_router_dom_1.Link, { to: "/".concat(selectedLanguage, "/projects/").concat(props.currentProject.id, "/sokosite/worksitediary/").concat(props.worksiteDiary.diary_uuid) }, "".concat((0, translation_1.getLocalization)('breadcrumb/worksiteDiary'), ": ").concat(props.worksiteDiary.name),
                        props.worksiteDiary.site_number
                            ? " - ".concat(props.worksiteDiary.site_number)
                            : '')),
                    React.createElement("span", null, (0, translation_1.getLocalization)('diaryEntriesView/dashboard'))),
                React.createElement(Greeting_1.Greeting, { message: React.createElement("span", null,
                        (0, translation_1.getLocalization)('sokosite/message/entryADay'),
                        '!') }),
                React.createElement("div", { className: "card-container" },
                    React.createElement("div", { className: "card-box-entry" },
                        React.createElement("div", { className: "card-box-header" },
                            React.createElement("h2", null, (0, translation_1.getLocalization)('worksiteDiaryView/dashboard/addNewEntry'))),
                        React.createElement("div", { className: "card-box-entry-content" },
                            React.createElement("div", { className: "entry-header" }, props.worksiteDiary && props.worksiteDiary.name && (React.createElement("span", null, "".concat((0, translation_1.getLocalization)('breadcrumb/worksiteDiary'))))),
                            React.createElement("div", { className: "entry-name" }, props.worksiteDiary && props.worksiteDiary.name && (React.createElement("span", null, "".concat(props.worksiteDiary.name), "".concat(props.worksiteDiary.site_number
                                ? " / ".concat(props.worksiteDiary.site_number)
                                : '')))),
                            React.createElement("div", { className: "entry-buttons" },
                                React.createElement(sok_ui_1.Button, { className: "date-box" },
                                    React.createElement("p", null,
                                        React.createElement("span", { className: "date-day" }, day),
                                        React.createElement("br", null),
                                        (0, text_1.capitalize)(monthName),
                                        " ",
                                        year)),
                                React.createElement(sok_ui_1.Button, { color: 'base-blue', className: "entry-button", text: (0, translation_1.getLocalization)('worksiteDiaryView/dashboard/addNewEntry'), disabled: acl.hasGrant(perm, acl.SUPER_ADMIN_GRANT) ||
                                        acl.hasGrant(worksiteDiaryPerm, acl.WORKSITE_DIARY_MASTER_GRANT)
                                        ? false
                                        : true, onClick: function () {
                                        setStartDate(moment().toDate());
                                        openModal();
                                    }, icon: React.createElement(sok_ui_1.Icon, { className: 'fa-plus' }) }),
                                React.createElement(NewEntryCalendar_1.default, __assign({ closeModal: closeModal, show: show, startDate: startDate, setStartDate: setDate }, props))))),
                    React.createElement("div", { className: "card-box-overview" },
                        React.createElement("div", { className: "card-box-header" },
                            React.createElement("h2", null, (0, translation_1.getLocalization)('worksiteDiaryView/dashboard/overview'))),
                        React.createElement("div", { className: "card-box-overview-content" }, props.stats.status === 'FETCHING' ? (React.createElement("div", { className: 'loading' },
                            React.createElement(sok_ui_1.LoadingSpinner, null))) : (props.stats.stats && (React.createElement(index_1.PieChart, __assign({}, props, { status: props.stats.status, data: [
                                {
                                    label: (0, translation_1.getLocalization)('worksiteDiaryView/dashboard/signed'),
                                    value: props.stats.stats.signed,
                                    color: '#6324b0'
                                },
                                {
                                    label: (0, translation_1.getLocalization)('worksiteDiaryView/dashboard/waitingForMaster'),
                                    value: props.stats.stats.waiting_for_masters_signature,
                                    color: '#ded1ee'
                                },
                                {
                                    label: (0, translation_1.getLocalization)('worksiteDiaryView/dashboard/waitingForSupervisor'),
                                    value: props.stats.stats.waiting_for_supervisors_signature,
                                    color: '#b698da'
                                }
                            ], width: props.viewportSize === 'MOBILE' ? 300 : 500, height: props.viewportSize == 'MOBILE'
                                ? 180
                                : props.viewportSize == 'TABLET'
                                    ? 200
                                    : 240 })))))),
                    React.createElement("div", { className: "card-box-latest" },
                        React.createElement("div", { className: "card-box-header" },
                            React.createElement("h2", null, (0, translation_1.getLocalization)('worksiteDiaryView/dashboard/latestEntries'))),
                        React.createElement("div", { className: "card-box-content" }, entryRows(props.entries.list, props))),
                    React.createElement("div", { className: "card-box-status" },
                        React.createElement("div", { className: "card-box-header" },
                            React.createElement("h2", null, (0, translation_1.getLocalization)('worksiteDiaryView/dashboard/worksiteStatus'))),
                        React.createElement("div", { className: "card-box-content" },
                            React.createElement(WorksiteStatus_1.default, { status: props.stats.status, stats: props.stats.stats }))))))));
});
